import React from 'react';
import {
  Container,
  ActivityLogDIv,
  UserContainer,
  ModuleContainer,
  DescriptionContainer,
  Label,
  Value,
  ActivityTimeStamp,
} from '@app/modules/activity-log/activity-log-component';
import moment from 'moment';
import { getActivityUserName } from '@app/modules/transaction-details/transactions-details';

type Props = {
  logs: any;
};
export default function ActivityLogMobile({ logs }: Props) {
  return (
    <Container>
      {logs && logs.length
        ? logs.map((log: any, index: number) => {
            return (
              <ActivityLogDIv key={index}>
                <ActivityTimeStamp>
                  {log.date
                    ? moment(log.date).format('MMM DD,YYYY hh:mm A')
                    : '--'}
                </ActivityTimeStamp>
                <UserContainer>
                  <Label>User Name</Label>
                  <Value>
                    {getActivityUserName(log.user ? log.user : '--')}
                  </Value>
                </UserContainer>
                <ModuleContainer>
                  <Label>Module</Label>
                  <Value>{log.item || '--'}</Value>
                </ModuleContainer>
                <DescriptionContainer>
                  <Label>Description</Label>
                  <Value>{log.description || '--'}</Value>
                </DescriptionContainer>
              </ActivityLogDIv>
            );
          })
        : null}
    </Container>
  );
}
